export const BS_COMMON_CONFIG = Object.freeze({
  bounceTime: 200,
  swipeBounceTime: 200,
  swipeTime: 4500,
  deceleration: 0.0045,
  eventPassthrough: 'vertical',
  observeDOM: true
})

export const LS_KEYS = Object.freeze({
  PGT: 'pgt',
  ACCOUNT: 'account',
  EMAIL: 'email',
  USERINFO: 'userinfo',
  AUTHORIZATION: 'authorization',
  ENCRYPTED_PWD: 'encrypt_pwd',
  NO_LOGNGER_SHOW_GESTURE_TIPS: 'no_longer_show_gesture_tips',
  GESTURE_RETRY_COUNT: 'gesature_retry_count',
  LOCALE: 'locale',
  VERIFY_CODE_TIME_PREFIX: 'verification_code_time_',
  ELEARNING_URL: 'elearning_utl',
  NEED_MODIFY_PWD: 'need_modify_pwd'
})

export const LF_KEYS = Object.freeze({
  ADVERTISEMENTS: 'advertisementS'
})

export const DEFAULT_GESTURE_RETRY_COUNT = 5

export const HOME_SHORTCUTS_COUNT = 3
